import * as actionTypes from '../types/adminMailing';

const initialState = {
  mailingList: [],
  mailingGet: {
    okRequest: false,
    loading: false
  },
  dataAddMalling: {
    loading: false,
    okRequest: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_MAILING:
      return {
        ...state,
        mailingGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_MAILING_SUCCESS:
      return {
        ...state,
        mailingList: payload,
        mailingGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_MAILING_FAIL:
      return {
        ...state,
        mailingGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.ADD_MAILING:
      return {
        ...state,
        dataAddMalling: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.ADD_MAILING_SUCCESS:
      return {
        ...state,
        dataAddMalling: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.ADD_MAILING_FAIL:
    case actionTypes.ADD_MAILING_CLEAR:
      return {
        ...state,
        dataAddMalling: {
          okRequest: false,
          loading: false
        }
      };

    default:
      return state;
  }
};

export default reducer;
